export default "__VITE_ASSET__CruYjcQX__"